<template>
  <div class="d-flex align-items-center">
    <div class="d-lg-none col-5">
      <SortTableMobileFirstColumnComponent :nbRows="nbColumns" :rows="column" />
    </div>
    <div class="col-lg-12 col-8 font-size">
      <div v-if="column.index === '5' && row[column.index]" class="d-inline-block -row">
        <button
          class="btn btn-success btn-sm btnStyle"
          v-tooltip="{ title: $t('studea_manager.incident_sheet.comment') }"
          @click="trigerModal(row[column.index])"
        >
          <FontAwesomeIcon icon="fa-light fa-comment-dots" />
        </button>
      </div>
      <div v-if="column.index === '6'" class="d-flex align-items-center">
        <span v-if="row[column.index] === incidentSheetManager().INCIDENT_INPROGRESS" class="badge bg-warning w-75">{{
          $t("studea_manager.incident_sheet.in_progress")
        }}</span>
        <span v-else-if="row[column.index] === incidentSheetManager().INCIDENT_ENCLOSE" class="badge bg-success w-75">{{
          $t("studea_manager.incident_sheet.closed")
        }}</span>
        <span v-else class="badge bg-primary w-75">{{ $t("studea_manager.incident_sheet.no_status") }}</span>
      </div>
    </div>
  </div>
  <ModalComponent
    :title="$t('studea_manager.incident_sheet.comment')"
    :content="modalContent"
    :opened="modalOpened"
    @hidden="cancelShow"
  />
</template>

<script>
import SortTableMobileFirstColumnComponent from "@/components/table/sortTable/SortTableMobileFirstColumnComponent.vue";
import ModalComponent from "@/components/ModalComponent.vue";
import { incidentSheetManager } from "@/services/incidentSheet/incident-sheet-manager";

export default {
  name: "SortTableIncidentSheetComponent",
  components: { ModalComponent, SortTableMobileFirstColumnComponent },
  props: {
    column: {
      type: Object,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
    nbColumns: {
      type: Number,
      required: true,
    },
    idKey: {
      type: Number,
      default: 0,
      required: false,
    },
  },
  data() {
    return {
      modalOpened: false,
      modalContent: "",
    };
  },
  methods: {
    incidentSheetManager() {
      return incidentSheetManager;
    },
    trigerModal(content) {
      this.modalOpened = true;
      this.modalContent = content;
    },
    cancelShow() {
      this.modalOpened = false;
      this.modalContent = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.badge {
  width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  border: none;

  @include up-to-lg {
    width: auto;
    max-width: 130px;
  }
}

svg {
  width: 15px !important;
  height: 15px !important;
}
</style>
